<template>
  <div class="wrapper d-flex justify-content-center align-items-center">
    <div class="flex-row w-100">
      <el-card class="sin-conexion text-center">
        <div class="row">
          <div class="col">
            <h1><span class="not-found-icon nc-icon nc-time-alarm pr-2"></span>Sin Conexión</h1>
            <p>Hay un error al conectarse con el servidor, por favor refresque el sitio o contactese con el
              administrador.</p>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <el-button @click="logout" type="primary" class="sinconexionaceptar">Aceptar
              <slot></slot>
            </el-button>
          </div>
        </div>

      </el-card>
    </div>
  </div>
</template>

<script>
import {Button, Card} from "element-ui";

export default {
  name: "SinConexion",
  components: {
    [Button.name]: Button,
    [Card.name]: Card,
  },
  methods: {
    logout() {
      this.$router.push({'path': '/logout'})
    }
  }
}
</script>

<style lang="scss">
.not-permission {
  .not-found-icon {
    margin-right: 10px;
  }

  .centered {
    h1, i {
      font-size: 50px;
    }

    p {
      font-size: 20px;
    }

    display: flex;
    padding-bottom: 150px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
}
</style>
